export enum Tags {
    LeftImageRightContent = 40
}
